import React from "react";

const BinaryComplements = () => {
  return (
    <div>
      <p>
        You must have heard of binary numbers and their many representations
        such as 1's complement, 2's complement, Excess-3 Code, Binary Coded
        Decimals (BCD) etc. It's obvious that all of these representations were
        invented for a reason, and this blog tries to navigate through an
        intuitive understanding of these concepts.
      </p>
    </div>
  );
};

export default BinaryComplements;
